import {BaseModel} from "../base.model";

export interface ReturnGoods extends BaseModel {
  
}

export const defaultReturnGoods: Readonly<ReturnGoods> = {};